import { noop } from 'helpers/utils';
import i18n from 'i18n/config';
import CrossIcon from 'styles/assets/icons/CrossIcon';
import GreenCircleTick from 'styles/assets/icons/GreenCircleTick';
import Box from 'UIKit/Box';
import IconButton from 'UIKit/IconButton';

import styles from '../phoneVerification.module.scss';

const textSuccessHeading = i18n.t('account:profile.phoneNoSuccess');

interface SuccessContentProps {
  closeModal: () => void;
}

const DefaultSuccessContent = ({ closeModal }: SuccessContentProps) => {
  return (
    <Box className={styles.mainContent} flex="flex" flexDir="column" alignItems="center">
      <IconButton
        data-testid="errorScreenClose"
        icon={<CrossIcon />}
        onClick={closeModal}
        onKeyDown={noop}
        className={styles.crossIcon}
      />
      <GreenCircleTick width={60} height={60} />
      <Box className={styles.successText} fontSize="md5" textColor="primary">
        {textSuccessHeading}
      </Box>
    </Box>
  );
};

export default DefaultSuccessContent;
